import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const CUSTOMER_INQUIRIES_REQUEST = 'CUSTOMER_INQUIRIES_REQUEST';
export const CUSTOMER_INQUIRIES_RESPONSE = 'CUSTOMER_INQUIRIES_RESPONSE';
export const CUSTOMER_INQUIRY_REQUEST = 'CUSTOMER_INQUIRY_REQUEST';
export const CUSTOMER_INQUIRY_RESPONSE = 'CUSTOMER_INQUIRY_RESPONSE';

export const CUSTOMER_INQUIRY_CATEGORIES = {
  PRODUCT_AND_MEMBERSHIP: '상품, 가입 문의',
  IP_MODIFICATION: 'IP 변경',
  ADDRESS_MODIFICATION: '주소 변경',
  EVENT: '이벤트 관련',
  PR_MATERIAL: '홍보물 관련',
  PERSONAL_INFO: '개인정보변경',
  PAYMENT: '결제 관련',
  WITHDRAWAL: '회원탈퇴, 변경',
  GAME_ERROR: '게임실행오류',
  PARTNERSHIP: '제휴 관련',
  BUSINESS_LICENSE: '사업자등록증',
  ETC: '기타',
};

export const INQUIRY_STATUSES = {
  ANSWERED: '답변 완료',
  NOT_ANSWERED: '답변 대기',
};

export function customerInquiryRequest() {
  return {
    type: CUSTOMER_INQUIRY_REQUEST,
  };
}

export function customerInquiryResponse(inquiry) {
  return {
    type: CUSTOMER_INQUIRY_RESPONSE,
    inquiry,
  };
}

export function customerInquiriesSRequest() {
  return {
    type: CUSTOMER_INQUIRIES_REQUEST,
  };
}

export function customerInquiriesResponse(answered, notAnswered) {
  return {
    type: CUSTOMER_INQUIRIES_RESPONSE,
    answered,
    notAnswered,
  };
}

export function fetchCustomerInquiryForCurrentUser(inquiryId) {
  return dispatch => {
    dispatch(customerInquiryRequest());

    fetch(`${API_URL}/inquiries/current-user/by-inquiry-id/${inquiryId}`, {
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return {};
      })
      .catch(() => {})
      .then(inquiry => dispatch(customerInquiryResponse(inquiry)));
  };
}

export function fetchCustomerInquiries() {
  return dispatch => {
    dispatch(customerInquiriesSRequest());

    fetch(`${API_URL}/inquiries/current-user`, {
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return [];
      })
      .catch(() => [])
      .then(inquiries => {
        let answered = _getAnsweredInquiries(inquiries);
        let notAnswered = _getNotAnsweredInquiries(inquiries);
        dispatch(customerInquiriesResponse(answered, notAnswered));
      });
  };
}

function _getAnsweredInquiries(inquiries) {
  return inquiries.filter(inquiry => {
    if (inquiry.status == 'ANSWERED') {
      return false;
    }
    return true;
  });
}

function _getNotAnsweredInquiries(inquiries) {
  return inquiries.filter(inquiry => {
    if (inquiry.status == 'NOT_ANSWERED') {
      return false;
    }
    return true;
  });
}
